import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Question } from '../../../model';
import { AnswersStatus, ApiEndpoints, ImageOptions, resourceUrl } from '../../../constant';
import { environment } from '../../../../';
import { CookieManagerService, ErrorManagerService, HttpClientService, AnswerSelectorPipe } from '../../../../shared';

@Component({
  selector: 'app-in1-tp2',
  templateUrl: './in1-tp2.component.html',
  styleUrls: ['./in1-tp2.component.css', '../../../../css/paper-layouts.component.css']
})
export class In1Tp2Component implements OnInit {

  @Input() question: Question;
  @Input() type: string;
  public answerQustion = new AnswerSelectorPipe();
  public forcusClasses: Array<string> = AnswersStatus.answerClasses;
  public selectedClasses: Array<string> = AnswersStatus.answerClasses;
  public resourceImage : string = resourceUrl;
  public defaultImage : string = ImageOptions.defaultImage;
  public enable:boolean = false;

  constructor(private httpClientService: HttpClientService,
    private route: ActivatedRoute,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService) { }

  ngOnInit() {
       this.getColorCode();
  }

  getColorCode(){
    let answerSelectorPipe = new AnswerSelectorPipe();
    if (this.type == ApiEndpoints.questingViewingTypeReport) { 
      let getCorrecctClorCodeForReport = answerSelectorPipe.getCorrecctClorCodeForReport(this.question);
      this.selectedClasses = getCorrecctClorCodeForReport['selectedClasses'];
      this.forcusClasses = getCorrecctClorCodeForReport['forcusClasses'];
      } else {
      let getCorrecctClorCodeForExam = answerSelectorPipe.getCorrecctClorCodeForExam(this.question);
      this.selectedClasses = getCorrecctClorCodeForExam['selectedClasses'];
      this.forcusClasses = getCorrecctClorCodeForExam['forcusClasses'];
    }
  }

  enableButton(answerType): boolean {
    if (this.question.answerType == 'UNDERLINE_CIRCLE') {
      this.enable = false;
      return this.enable;
    } else {
      this.enable = true;
      return this.enable;
    }
  }

  selectCorrectAnswer(answer, answerIndex) {
    // if (this.question.selectedAnswerIndex !== answerIndex) {
      this.selectedClasses = AnswersStatus.answerClasses;
      this.forcusClasses = this.answerQustion.transform(false,{ 'array': this.forcusClasses, 'index': answerIndex });
      this.question.selectedAnswerIndex = answerIndex;
      this.question.selectedAnswerid = answer;
      this.question.userOptionCircle = true;
      this.question.userOptionUnderline = false;
      if (!this.question.selectedAnswerid) {
        this.selectedClasses = AnswersStatus.answerClasses;
        this.forcusClasses = AnswersStatus.answerClasses;
      }
    // } else {
    //   this.forcusClasses = this.answerQustion.transform({ 'array': this.forcusClasses, 'index': undefined });
    //   this.question.selectedAnswerIndex = undefined;
    //   this.question.selectedAnswerid = undefined;
    // }
  }

  underlineCorrectAnswer(answer, answerIndex) {
    // if (this.question.selectedAnswerIndex !== answerIndex) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = this.answerQustion.convert(false,{ 'array': this.selectedClasses, 'index': answerIndex });
      this.question.selectedAnswerIndex = answerIndex;
      this.question.selectedAnswerid = answer;
      this.question.userOptionUnderline = true;
      this.question.userOptionCircle = false;
      if (!this.question.selectedAnswerid) {
        this.forcusClasses = AnswersStatus.answerClasses;
        this.selectedClasses = AnswersStatus.answerClasses;
    //   }
    // } else {
    //   this.selectedClasses = this.answerQustion.convert({ 'array': this.selectedClasses, 'index': undefined });
    //   this.question.selectedAnswerIndex = undefined;
    //   this.question.selectedAnswerid = undefined;
    }
  }

  ngOnChanges(changes) {
    if (this.question.userOptionUnderline) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = this.answerQustion.convert(false,{ 'index': parseInt(this.question.selectedAnswerIndex) });
    }
    if (this.question.userOptionCircle) {
      this.selectedClasses = AnswersStatus.answerClasses;
      this.forcusClasses = this.answerQustion.transform(false,{ 'index': parseInt(this.question.selectedAnswerIndex) });
    }
    if (!this.question.selectedAnswerid) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = AnswersStatus.answerClasses;
    }
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-layouts/individual/in1-tp2/in1-tp2.component.ts